import L from "leaflet";

const EventIcon = () => {
  return L.divIcon({
    className: "custom-stop-label",
    html: `
          <div class="relative">
            <img 
              src="/icons/warning-icon.png"
              class="w-5 h-5"
              alt="Evento"
            />
          </div>
        `,
    iconSize: [10, 10],
    iconAnchor: [10, 10],
    popupAnchor: [0, -10],
  });
};

export default EventIcon;
